import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Sofía', 'Camila', 'Valentina', 'Lucía', 'Martina', 'Julieta', 'Agustina', 'Catalina', 'Florencia', 'Micaela', 'Rocío'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'Bogotá', 'Lima', 'Santiago', 'Montevideo', 'Medellín', 'Quito'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Auto-dismiss after 4 seconds
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 5000);
    // Then random interval between 8-12 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        setTimeout(showPopup, Math.random() * 4000 + 8000);
      }
    }, 12000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-113">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:w-80 bg-white rounded-xl shadow-xl p-3 z-50 border border-salvia-light flex items-center gap-3" data-id="element-114">
          <div className="bg-salvia-light p-2 rounded-full flex-shrink-0" data-id="element-115">
            <CheckCircle2 className="w-5 h-5 text-salvia" data-id="element-116" />
          </div>
          <div data-id="element-117">
            <p className="text-sm font-medium text-gray-900 leading-tight" data-id="element-118">
              {data.name} de {data.city}
            </p>
            <p className="text-xs text-gray-500 mt-0.5" data-id="element-119">
              compró el Protocolo Endo-Rescate
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}